import React, {Component} from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import SaveIcon from '@mui/icons-material/Save';
import app from '../base/api';
import ReactJson from 'react-json-view'


const theme = createTheme();

class Rutas extends Component {

  constructor () {
    super();
    this.state = {
      origen: '',
      destino: '',
      response: {},
    };
  }

  setOrigen = (event, value) => {
    this.setState({
      origen: event.target.value
    });
  }

  setDestino = (event, value) => {
    this.setState({
      destino: event.target.value
    });
  }

  calculate = async () => {
    var form = new FormData();
    form.append('data', JSON.stringify(this.state));
    let data = await app.post(`/api/distance/`, form, {}, this.addError);
    if (data) {
      this.setState({response: data})
    }
  }

  render () {
      return (
        <ThemeProvider theme={theme}>
          <Container maxWidth="lg" component="main">
              <Typography component="h1" variant="h5">
                Calcular Ruta
              </Typography>
              <Grid key="origen" item xs={12}><TextField
                margin="normal"
                key="origen"
                fullWidth
                type="text"
                id="origen"
                onChange={this.setOrigen}
                value={this.state.origen}
                label="Origen"
              /></Grid>
              <Grid key="destino" item xs={12}><TextField
                margin="normal"
                key="destino"
                fullWidth
                type="text"
                id="destino"
                onChange={this.setDestino}
                value={this.state.destino}
                label="Destino"
              /></Grid>
              <Box noValidate sx={{ mt: 1 }}>
                <Button
                  type="button"
                  onClick={this.calculate}
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  <SaveIcon />
                </Button>
                <ReactJson src={this.state.response} />
              </Box>
          </Container>
        </ThemeProvider>

      )
  }

}

export default Rutas;
